export default "__VITE_ASSET__69831bbf__"